export const Kind = 'BILLING' as const;

export enum Status {
  Created = 'CREATED',
  Exporting = 'EXPORTING',
  ExportingManually = 'EXPORTING_MANUALLY',
  ExportNeedsReview = 'EXPORT_NEEDS_REVIEW',
  ExportedSuccessfully = 'EXPORTED_SUCCESSFULLY',
  ExportedManually = 'EXPORTED_MANUALLY',
  ExistingData = 'EXISTING_DATA',
}
